// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hardwareOverviewDetails__vN83t {
  background-color: var(--tables-main-surface);
}

.hardwareOverviewDetailsBody__eADdB {
  height: calc(100vh - 105px);
  padding: 25px;
  overflow-y: auto;
}
.hardwareOverviewDetailsBody__eADdB::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.hardwareOverviewDetailsBody__eADdB::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.hardwareOverviewDetailsBody__eADdB::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.hardwareOverviewDetailsBody__eADdB::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.hardwareOverviewDetailsBody__eADdB > div:not(:first-child) {
  border-top: 1px solid var(--tables-primary-row-stroke);
}
@media (max-width: 1100px) {
  .hardwareOverviewDetailsBody__eADdB {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/HardwareOverviewDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,4CAAA;AAzEF;;AA4EA;EACE,2BAAA;EACA,aAAA;EACA,gBAAA;AAzEF;AAkBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,+BAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,kBAAA;AAnBJ;AA4DE;EACE,sDAAA;AA1DJ;AA6DE;EAXF;IAYI,aAAA;EA1DF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.hardwareOverviewDetails {\n  background-color: var(--tables-main-surface);\n}\n\n.hardwareOverviewDetailsBody {\n  height: calc(100vh - 105px);\n  padding: 25px;\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  & > div:not(:first-child) {\n    border-top: 1px solid var(--tables-primary-row-stroke);\n  }\n\n  @media (max-width: 1100px) {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hardwareOverviewDetails": `hardwareOverviewDetails__vN83t`,
	"hardwareOverviewDetailsBody": `hardwareOverviewDetailsBody__eADdB`
};
module.exports = ___CSS_LOADER_EXPORT___;
